import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Check, Loader2 } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const sid = params.get("session_id");
  const [status, setStatus] = useState("pending");

  useEffect(() => {
    if (!sid) { setStatus("error"); return; }
    let attempts = 0;
    const poll = async () => {
      attempts++;
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") { setStatus("paid"); return; }
        if (data.status === "expired") { setStatus("expired"); return; }
      } catch (err) { console.error("payment status poll failed", err); /* keep polling */ }
      if (attempts < 8) setTimeout(poll, 2000);
      else setStatus("timeout");
    };
    poll();
  }, [sid]);

  return (
    <div className="container-optia py-16 max-w-lg mx-auto animate-fade-in">
      <Card className="card-soft">
        <CardContent className="p-10 text-center">
          {status === "pending" && (<><Loader2 className="w-10 h-10 mx-auto text-teal-500 animate-spin" /><h1 className="font-display text-2xl font-semibold text-navy-900 mt-5">Confirmando pagamento…</h1><p className="text-slate-600 mt-2">Só um instante.</p></>)}
          {status === "paid" && (<><div className="h-14 w-14 rounded-full bg-teal-500 grid place-items-center mx-auto"><Check className="w-7 h-7 text-white" /></div><h1 className="font-display text-2xl font-semibold text-navy-900 mt-5" data-testid="pay-success">Pagamento confirmado!</h1><p className="text-slate-600 mt-2">Sua consulta foi confirmada. Você pode entrar na sala pelo painel no horário marcado.</p><Button className="mt-6 bg-teal-500 hover:bg-teal-600 rounded-xl" onClick={()=>nav("/dashboard")} data-testid="pay-goto-dashboard">Ir para o painel</Button></>)}
          {(status === "expired" || status === "timeout" || status === "error") && (<><h1 className="font-display text-2xl font-semibold text-navy-900">Não foi possível confirmar</h1><p className="text-slate-600 mt-2">Tente novamente ou verifique seu painel.</p><Button className="mt-6" variant="outline" onClick={()=>nav("/dashboard")}>Voltar</Button></>)}
        </CardContent>
      </Card>
    </div>
  );
}
